var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('div',{staticClass:"article__image"},[_c('img',{attrs:{"src":_vm.imageUrl,"alt":"image"}})]),_c('div',{staticClass:"article__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"article__date"},[_vm._v(" "+_vm._s(_vm.momentDate)+" de "+_vm._s(_vm.author)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }